import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { Menu } from 'primeng/menu';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService } from 'primeng/api';
import { HostelService } from 'src/app/private/services/hostel.service';
import { CreateHostelComponent } from "../../components/hostel/create-hostel/create-hostel.component";
import { DeleteHostelComponent } from "../../components/hostel/delete-hostel/delete-hostel.component";

@Component({
  selector: 'app-hostel-configuration',
  imports: [ToolBarComponent, SharedModule, CreateHostelComponent, DeleteHostelComponent],
  templateUrl: './hostel-configuration.component.html',
  styleUrl: './hostel-configuration.component.scss'
})
export class HostelConfigurationComponent {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddHostel: boolean = false;
  editLeadFieldData: boolean = false;
  isEditHostel: boolean = false;
  isDeleteHostel: boolean = false;
  hostelData: any;

  items: any[] = [];

  columns: any[] = [
    { field: 'hostel_name', header: 'Hostel Name' },
    { field: 'room_type', header: 'Room Type' },
    { field: 'capacity', header: 'Capacity' },
    { field: 'fee_amount', header: 'Fee Amount' , type: 'fee_amount' },
    // { field: 'currency', header: 'Currency' },
    { field: 'facilities_display', header: 'Facilities', type: 'facilities' },
    { field: 'status', header: 'Status' },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];

  constructor(
    private api: HostelService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  HostelActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Hostel Category',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditHostel = true;
          }
        },
        {
          label: 'Delete Hostel Category',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteHostel = true;
          }
        }
      ]
    }
  ]

  setHostelEditData(rowData: any) {
    this.hostelData = rowData;
  }

  loadData(event: any) {
    const page = event.first || 0;
    const size = event.rows || this.rows;

    const param = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"hostel_category\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.loading = true;

    this.api.getAllHostelCategoriesWithCount(param).subscribe({
      next: (data) => {
        // Process facilities for display
        this.dataSource = (data.rows || []).map((item: any) => ({
          ...item,
          facilities_display: this.formatFacilities(item.facilities)
        }));
        this.totalRecords = data.count || 0;
        this.loading = false;
      },
      error: (error) => {
        console.error('Failed to load hostel categories.', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load hostel categories.' });
        this.initialLoad = false;
        this.loading = false;
      },
    });
  }

  formatFacilities(facilities: any): string {
    if (!facilities) return 'None';
    
    const availableFacilities = Object.keys(facilities)
      .filter(key => facilities[key] === true)
      .join(', ');
    
    return availableFacilities || 'None';
  }

  reloadData() {
    this.loadData({ first: 0, rows: this.rows });
  }

  handleHostel() {
    this.isAddHostel = true;
  }

  handleCloseDialog() {
    this.isAddHostel = false;
  }

}
